export const queryRunnerStyles = () => {
  return {
    verbSelector: {
      title: {
        paddingRight: 0,
        color: '#ffffff !important',
        background: ''
      },
      caretDown: {
        color: '#ffffff !important'
      }
    },
    iconButton: {
      root: {
        float: 'right',
        border: '1px solid',
        width: '100%'
      }
    },
    queryButtonStyles: {
      root: {
        flexBasis: '75px'
      }
    },
    shareQueryButtonStyles: {
      root: {
        flexBasis: '40px'
      }
    }
  };
};